import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
`;

export const Label = styled.p`
  text-align: left;
  margin: 0px;
`;

export const SelectContain = styled.section`
  .ant-select-selector {
    width: 100%;
    min-height: 45px;
    padding: 10px 12px;
  }
  .ant-select-show-search.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 0.5rem;
  }
  .ant-select-multiple:not(.ant-select-customize-input) .ant-select-selector {
    width: 100%;
    padding: 10px 12px;
  }
  .ant-select-clear {
    margin-right: 18px;
  }
  p {
    margin: 0 0 0.7rem;
    color: var(--texto-color);
    letter-spacing: 0.1rem;
    font-size: var(--font-tamanho);
  }
`;
